<template>
    <van-popup
        v-if="customerTransferPopupShow"
        :value="customerTransferPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container customer_allocation_wrap" v-loading="loading">
            <div class="returnNavBar">
                <ReturnNavBar
                    :isCustomReturnEvent="true"
                    :isTitleNormal="true"
                    :isAllFunctions="true"
                    title="返回"
                    @returnEvent="handleClickClose"
                >
                </ReturnNavBar>
            </div>
            <div class="mobile_container">
                <van-form
                    label-width="9.5em"
                    input-align="right"
                    scroll-to-error
                    :show-error-message="false"
                    ref="customerForm"
                    class=""
                >
                    <van-field
                        required
                        v-model="formData.sea_name"
                        name="转移至"
                        label="转移至"
                        placeholder="请选择"
                        is-link
                        readonly
                        @click="handleClickSelectHighSeas"
                        :rules="[{ required: true, message: '请选择' }]"
                    >
                    </van-field>
                </van-form>
                <div class="operate_customer_list_box">
                    <div class="operate_customer_list_box_title">您将要转移以下客户</div>
                    <ul class="operate_customer_list">
                        <li v-for="item in companyList" :key="item.id">
                            <p class="ellipsis">{{ item.name && item.name.value }}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="add_footer_wrap">
                <van-button round block type="info" @click="handleClickConfirm">确定</van-button>
            </div>

            <!-- 公海选择 -->
            <van-overlay
                :custom-style="{ background: 'rgba(0, 0, 0, 0.3)', zIndex: 99999 }"
                v-if="highSeasSelectVisible"
                :show="highSeasSelectVisible"
            >
                <div class="radio_option_wrap">
                    <ul class="radio_option_list">
                        <li
                            v-for="item in highSeasActions"
                            class="radio_option_item"
                            @click="handleHighSeasSelect(item)"
                            v-text="item.name"
                        ></li>
                    </ul>
                    <div class="cancel_btn" @click="highSeasSelectVisible = false">取消</div>
                </div>
            </van-overlay>
        </div>
    </van-popup>
</template>

<script>
import { GetHighSeasManagementList, CustomerPublicTransfer } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "CustomerTransfer",
    components: { ReturnNavBar },
    props: {
        customerTransferPopupShow: {
            type: Boolean,
            default: false,
        },
        sea_id: "",
        companyList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            loading: false,
            formData: {
                sea_id: "",
                sea_name: "",
            },
            highSeasSelectVisible: false, // 公海切换
            highSeasActions: [],
        };
    },
    created() {
        this.getHighSeasManagementList();
    },
    methods: {
        handleClickClose() {
            this.$emit("update:customerTransferPopupShow", false)
        },
        handleClickSelectHighSeas() {
            this.highSeasSelectVisible = true;
        },
        // 公海切换取消
        onCancelHighSeasSelect() {
            this.highSeasSelectVisible = false;
        },
        // 公海切换确认
        handleHighSeasSelect(item) {
            this.formData.sea_id = item.value;
            this.formData.sea_name = item.name;
            this.highSeasSelectVisible = false;
        },
        // 获取公海列表
        getHighSeasManagementList() {
            GetHighSeasManagementList().then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    this.highSeasActions = data
                        .filter((item) => item.id != this.sea_id)
                        .map((item) => ({ name: item.seas_name, value: item.id }));
                }
            });
        },
        handleClickConfirm() {
            this.$refs.customerForm.validate().then(() => {
                this.loading = true;
                const params = {
                    sea_id: this.formData.sea_id,
                    customer_ids: this.companyList.map((item) => item.id),
                };
                CustomerPublicTransfer(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$emit("update:customerTransferPopupShow", false)
                                    this.$emit("transferSuccess")
                                },
                            });
                        } else {
                            this.$toast({
                                message: res.message,
                                type: "fail",
                            });
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/customers.scss";
.customer_allocation_wrap {
    .mobile_container {
        padding: 10px 16px;
    }
}
.radio_option_wrap {
    width: 100%;
    height: 100%;
    padding: 0 16px 35px;
    display: flex;
    flex-direction: column;
    justify-content: end;

    .radio_option_list {
        border-radius: 8px;
        max-height: calc(100% - 90px);
        overflow-y: auto;

        .radio_option_item {
            background-color: #ffffff;
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            padding: 10px 0;
            color: #666666;
            border-bottom: 1px solid #dedede;

            &:first-child {
                border-radius: 8px 8px 0 0;
            }

            &:last-child {
                border-bottom: none;
                border-radius: 0 0 8px 8px;
            }
        }
    }

    .cancel_btn {
        background-color: #ffffff;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        padding: 10px 0;
        color: #666666;
        border-radius: 8px;
        box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
        margin-top: 10px;
    }
}
</style>
